var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.92639 27.5354C9.33666 27.5354 10.6668 26.9865 11.6644 25.9889L17.0651 20.5882C17.4457 20.2076 18.1028 20.2076 18.4834 20.5882L23.9041 26.0089C24.9017 27.0065 26.2319 27.5554 27.6422 27.5554H28.7079L21.8689 34.3944C19.7334 36.5299 16.2718 36.5299 14.1364 34.3944L7.27734 27.5354H7.92639Z",
    fill: "#4BB8A9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6422 8.4406C26.2279 8.4406 24.9017 8.98948 23.9041 9.98709L18.4834 15.4078C18.0948 15.7965 17.4537 15.8005 17.0651 15.4078L11.6644 10.0071C10.6668 9.00951 9.33666 8.46063 7.92639 8.46063H7.27734L14.1364 1.60158C16.2718 -0.53386 19.7334 -0.53386 21.8689 1.60158L28.7079 8.4406H27.6462H27.6422Z",
    fill: "#4BB8A9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1.60559 14.13L5.68816 10.0474H7.92777C8.90134 10.0474 9.85488 10.444 10.544 11.1331L15.9447 16.5338C16.4495 17.0386 17.1146 17.291 17.7756 17.291C18.4367 17.291 19.1018 17.0386 19.6066 16.5338L25.0273 11.1131C25.7164 10.424 26.67 10.0273 27.6435 10.0273H30.2958L34.3984 14.13C36.5339 16.2654 36.5339 19.727 34.3984 21.8624L30.2958 25.965H27.6435C26.67 25.965 25.7164 25.5684 25.0273 24.8793L19.6066 19.4585C18.629 18.481 16.9183 18.481 15.9407 19.4585L10.54 24.8552C9.85087 25.5443 8.89734 25.941 7.92377 25.941H5.68416L1.60158 21.8584C-0.53386 19.723 -0.53386 16.2614 1.60158 14.1259",
    fill: "#4BB8A9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPix);
export default __webpack_public_path__ + "static/media/pix.d0f5dc84e847dbd0c8e37765cf4e12fc.svg";
export { ForwardRef as ReactComponent };